module.exports = __webpack_public_path__ + "img/leftArrow.b80878ad.svg";